import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanBEApi } from "~/Services";

export interface DocumentDetailsResponse {
  id: number;
  title: string;
  description: string;
  fromName: string;
  fromMail: string;
  subject: string;
  body: string;
  header: string;
  footer: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updateBy: string;
}

// edit api call
const fetchUsersDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await eramanBEApi.get(`/admin/mails/get?id=${id}`);
  return response.data;
};

const useEdmMailerDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["edmMailerDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchUsersDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useEdmMailerDocumentDetails };
